import { Component, OnInit, RendererFactory2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { Store } from 'src/app/core/store/store';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { environment } from 'src/environments/environment';
// declare function zE(a,b): any;
declare function zE(a, b, c): any;
declare function closeNavMobile(): any;

@Component({
  selector: 'app-new-sidebar',
  templateUrl: './new-sidebar.component.html',
  styleUrls: ['./new-sidebar.component.css']
})
export class NewSidebarComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService, private route: ActivatedRoute, private store: Store, private partnerService: PartnerService) { }
  user: any;
  optionalModal = false;
  hideSidebar = false;
  programElementParams = ' '

  ngOnInit(): void {

    zE('messenger:set', 'zIndex', -2);

 



  }

  ngAfterViewChecked() {
    var iframes = document.querySelectorAll('iframe')
    if (iframes) {
      iframes.forEach((iframe) => {
        if(iframe.title === 'Button to launch messaging window'){
            iframe.style.display = 'none';
        }
      })
    }
    
  }

  navigateToDashboard() {
    closeNavMobile();
    this.router.navigate(['/learning-insights']);
  }

  closeNav() {

  }

  faqClick() {
  }

  logout() {
    this.authService.logout();
    this.partnerService.clearSession();
    this.store.set('elements', undefined);
    this.store.set('user', null);
    this.store.set('metrics', undefined);
    this.store.set('organizations', []);
    this.store.set('activations', []);
    this.store.set('currentOrganization', undefined);
    this.store.set('currentActivation', undefined);
  }

}
